module.exports = __webpack_public_path__ + "img/teamwork-icon-6.1195f295.png";